import React, { forwardRef } from 'react'

import { CurrencyEurIcon, CurrencyGbpIcon, CurrencyUsdIcon } from '@arcade/web/icons/react'

import { ArcadeHelpTextComponentProps } from '../Input/ArcadeHelpText'
import ArcadeInput, { ArcadeInputProps } from '../Input/ArcadeInput'

export type CurrencySymbol = '$' | '£' | '€'

export interface CashtagInputProps extends Omit<ArcadeInputProps, 'type'>, ArcadeHelpTextComponentProps {
  /**
   * @default '$'
   */
  currencySymbol?: CurrencySymbol
  placeholder: string
}

const DEFAULT_CURRENCY_SYMBOL: CurrencySymbol = '$'

const CURRENCY_ICON_MAP = {
  $: CurrencyUsdIcon,
  '£': CurrencyGbpIcon,
  '€': CurrencyEurIcon,
} as const

const CashtagInput = forwardRef<HTMLInputElement, CashtagInputProps>(
  ({ currencySymbol = DEFAULT_CURRENCY_SYMBOL, placeholder, value, ...restProps }, ref) => {
    const LeadingIcon = CURRENCY_ICON_MAP[currencySymbol] as ArcadeInputProps['LeadingIcon']

    return (
      <ArcadeInput
        aria-label={`${currencySymbol}cashtag`}
        {...restProps}
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
        LeadingIcon={LeadingIcon}
        placeholder={placeholder}
        ref={ref}
        spellCheck={false}
        type="text"
        value={value}
      />
    )
  }
)

CashtagInput.displayName = 'CashtagInput'

export default CashtagInput
